import { createPageTableSchema } from '@state/_shared/tableComponentStateSchema';
import { bricklinkUpdateDialogStateSchema } from '@state/_shared/bricklinkUpdateDialogStateSchema';

// Define the specific structure for a row in the user inventory table
const userInventoryRowSchema = {
    type: 'object',
    properties: {
        // Core identifier
        id: { type: 'string', default: '' },
        
        // Item details
        item_number: { type: 'string', default: '' },
        part_name: { type: 'string', default: '' },
        description: { type: 'string', default: '' },
        image_url: { type: 'string', default: '' },
        
        // Color information
        color_id: { type: 'number', default: 0 },
        color_name: { type: 'string', default: '' },
        
        // Inventory details
        quantity: { type: 'number', default: 0 },
        price: { type: 'number', default: 0.00 },
        condition: { type: 'string', default: 'U' }, // Default to Used
        
        // Location
        location_id: { type: ['string', 'number', 'null'], default: null },
        location_name: { type: ['string', 'null'], default: null },
        
        // Timestamps
        createdAt: { type: ['string', 'null'], default: null },
        updatedAt: { type: ['string', 'null'], default: null }
    }
};

// Define the possible action states for rows in this specific table
const userInventoryRowActions = {
    isUpdating: { type: 'boolean', default: false },
    isDeleting: { type: 'boolean', default: false },
    isExporting: { type: 'boolean', default: false },
    isUpdatingPrice: { type: 'boolean', default: false },
    isSyncing: { type: 'boolean', default: false }
};

// Create the table schema specific to this page
const pageTableSchema = createPageTableSchema(userInventoryRowSchema, userInventoryRowActions);

// Note: Removed default sorting to allow persistence to work properly
// Initial sorting can be set in the component if no persisted value exists

// Schema definition for user inventory page state
export const userInventoryPageStateSchema = {
    // Table State (using the shared schema)
    table: pageTableSchema,
    
    // Table Filters
    filters: {
        type: 'object',
        properties: {
            showZeroQuantityItems: { type: 'boolean', default: false, persist: true },
            showUnconsolidatedInventory: { type: 'boolean', default: false, persist: true }
        }
    },

    // Dialog States
    syncWarningDialog: {
        type: 'object',
        properties: {
            isOpen: { type: 'boolean', default: false }
        }
    },
    failedItemsDialog: {
        type: 'object',
        properties: {
            isOpen: { type: 'boolean', default: false },
            items: {
                type: 'array',
                items: {
                    type: 'object',
                    properties: {
                        error: { type: 'string' },
                        context: { type: 'string' }
                    }
                },
                default: []
            }
        }
    },
    bricklinkUpdateDialog: bricklinkUpdateDialogStateSchema,

    // Action States
    syncButton: {
        type: 'object',
        properties: {
            isSyncing: { type: 'boolean', default: false }
        }
    },
    bsxImport: {
        type: 'object',
        properties: {
            isImporting: { type: 'boolean', default: false }
        }
    },
    
    // Individual item syncing state
    syncingItems: {
        type: 'object',
        default: new Set(),
        transform: {
            // Convert Set to Array for serialization and back
            serialize: (value) => value instanceof Set ? Array.from(value) : [],
            deserialize: (value) => new Set(Array.isArray(value) ? value : [])
        }
    }
};

export default userInventoryPageStateSchema;
